import React from "react";

const teamMembers = [
  {
    name: "Steven Nocka",
    role: "Co-Founder & Board Chair",
    image: "/steven.png",
    alt: "Steven Nocka",
    description: "Strategic advisor overseeing governance and long-term vision.",
  },
  {
    name: "Sheila Uwimana",
    role: "COO & Co-Founder",
    image: "/sheilla.png",
    alt: "Sheila Uwimana",
    description: "Operations expert ensuring efficient delivery of our programs.",
  },
  {
    name: "Mpano Athos",
    role: "Software Engineer",
    image: "/Mpano Athos.jpg",
    alt: "Mpano Athos",
    description: "Technical innovator building solutions for financial access.",
  },
];

function Team() {
  return (
    <section id="team" className="min-h-screen bg-white pt-28 pb-20 text-slate-900">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="border-b border-slate-200 pb-10">
            <span className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">
              Meet Our Leadership
            </span>
            <div className="mt-6 grid gap-8 lg:grid-cols-[1.3fr_0.7fr] lg:items-end">
              <div>
                <h1 className="text-4xl font-bold leading-tight text-slate-900 md:text-5xl">
                  Leadership committed to inclusive finance and long-term impact.
                </h1>
                <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-600">
                  Our team brings together strategic leadership, operational execution, and technical capability
                  to advance financial inclusion and support underserved entrepreneurs across Rwanda.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-8">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                  Team Focus
                </p>
                <p className="mt-3 text-3xl font-bold text-slate-900">Leadership and Delivery</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-3">
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm transition duration-200 hover:shadow-md"
              >
                <img
                  src={member.image}
                  alt={member.alt}
                  className="mx-auto mb-6 h-32 w-32 rounded-full border-4 border-slate-200 object-cover shadow-sm"
                />
                <h3 className="mb-2 text-2xl font-semibold text-slate-900">{member.name}</h3>
                <p className="mb-4 text-base font-semibold uppercase tracking-[0.16em] text-slate-500">
                  {member.role}
                </p>
                <p className="leading-7 text-slate-600">{member.description}</p>
              </div>
            ))}

            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-8 shadow-sm md:col-span-2 lg:col-span-3">
              <h2 className="text-2xl font-semibold text-slate-900">Leadership Approach</h2>
              <p className="mt-4 max-w-4xl text-lg leading-8 text-slate-700">
                We combine governance, operational discipline, and technical problem-solving to deliver financial
                inclusion programs that are practical, accountable, and responsive to community needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
